import { splitData, splitNumbers } from '@helios/utils'
import {
  BulkExternalTransactionsGetRequest,
  FindBulkExternalTransactionsForm,
} from '../models/bulk-external-transactions.model'

/**
 * Constructor for a BulkExternalTransactionsGetRequest, which is created from form data.
 */
export function createBulkExtTransGetRequest(
  form: FindBulkExternalTransactionsForm,
): BulkExternalTransactionsGetRequest {
  const rootIds = splitNumbers(form.rootIds)
  const hasRootIds = rootIds.length > 0
  const isAccountIdType = form.rootIdType === 'account'
  const isClientIdType = form.rootIdType === 'client'
  const isExternalTranIds = form.rootIdType === 'transaction'
  const accountIds = hasRootIds && isAccountIdType ? rootIds : undefined
  const clientIds = hasRootIds && isClientIdType ? rootIds : undefined
  const externalTranIds = hasRootIds && isExternalTranIds ? rootIds : undefined
  const assetIds =
    form.assetIds !== undefined && form.assetIds.length > 0
      ? splitData(form.assetIds)
      : undefined
  const tranTypes =
    form.tranTypes !== undefined && form.tranTypes.length > 0
      ? form.tranTypes
      : undefined

  const dataSource =
    form.dataSourceType && form.dataSourceType.length > 0
      ? form.dataSourceType
      : undefined

  const status =
    form.statuses && form.statuses.length > 0
      ? { filterType: 'set', values: form.statuses }
      : undefined

  return {
    filter: {
      accountIds,
      clientIds,
      externalTranIds,
      beginDate: form.startDate,
      endDate: form.endDate,
      assetIds,
      tranTypes,
      dataSourceType: dataSource,
      status,
    },
  }
}
